module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Cassete-b26bc861142dd196e1841979a4fbb1e9.svg";